"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenResponse = void 0;
exports.tokenResponse = {
    status: "SUCCESS",
    token: "SOMETHING.SOMESTRING.KEY",
    tenantPath: "mgb"
};
//# sourceMappingURL=token-response.js.map